import './styles';

const htmlContent = `
<div class="legal-doc" data-astro-cid-jpg5vglg=""><div class="legal-doc-heading" data-astro-cid-jpg5vglg=""><h1 data-astro-cid-jpg5vglg="">Legend Bank Privacy Policy</h1></div><p class="updated" data-astro-cid-jpg5vglg="">Effective: May 15, 2025</p><p class="updated" data-astro-cid-jpg5vglg="">Last updated: May 15, 2025</p><div class="body" data-astro-cid-jpg5vglg="">
<p><strong>FACTS</strong></p>
<p><strong>WHAT DOES LEGEND BANK DO WITH YOUR PERSONAL INFORMATION?</strong></p>
<p><strong>Why?</strong></p>
<p>Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share and protect your personal information. Please read this notice carefully to understand what we do.</p>
<p><strong>ACH Transactions</strong></p>
<p>The types of personal information we collect and share depend on the product or service you have with us. This information can include:</p>
<ul>
<li>Social Security number and income</li>
<li>Account Balances and payment history</li>
<li>Credit history and credit scores</li>
</ul>
<p>When you are no longer our customer, we continue to share your information as described in this notice.</p>
<p><strong>How?</strong></p>
<p>All financial companies need to share customer’s personal information to run their everyday business. In the section below, we list the reasons financial companies can share their customer’s personal information; the reasons Legend Bank chooses to share; and whether you can limit this sharing.</p>
<p><strong>Reasons we can share your personal information</strong></p>
<p><strong>Does Legend Bank share?</strong></p>
<p><strong>Can you limit this sharing?</strong></p>
<p><strong>For our everyday business purposes</strong> —Such as to process your transactions, maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</p>
<p>Yes</p>
<p>No</p>
<p><strong>For our marketing purposes</strong> —To offer our products and services to you</p>
<p>Yes</p>
<p>No</p>
<p><strong>For joint marketing with other financial companies</strong></p>
<p>Yes</p>
<p>No</p>
<p><strong>For our affiliates’ everyday business purposes</strong> —Information about your transactions and experiences</p>
<p>Yes</p>
<p>No</p>
<p><strong>For our affiliates’ everyday business purposes</strong> —About your credit worthiness</p>
<p>No</p>
<p>We don’t share</p>
<p><strong>For nonaffiliates to market to you</strong></p>
<p>No</p>
<p>We don’t share</p>
<p><strong>Questions?</strong></p>
<p>Call <strong>800-873-5604</strong> or go to <a href="http://www.legend.bank"><strong></strong></a><strong><a href="http://www.legend.bank">www.legend.bank</a></strong></p>
<p><strong>Who we are</strong></p>
<p><strong>Who is providing this notice?</strong></p>
<p>Legend Bank</p>
<p>Legend Bancorp, Inc.</p>
<p><strong>What we do</strong></p>
<p><strong>How does Legend Bank protect my personal information?</strong></p>
<p>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings.We use a layered security approach including encryption, firewalls, control access and other best practice security measures.</p>
<p><strong>How does Legend Bank collect my personal information?</strong></p>
<p>We collect your personal information, for example, when you:</p>
<p>▪ Open an account or deposit money
▪ Pay your bills or apply for a loan
▪ Use your debit card</p>
<p>We also collect your personal information from others, such as credit bureaus, affiliates, or other companies.</p>
<p><strong>Why can’t I limit all sharing?</strong></p>
<p>Federal law gives you the right to limit only:</p>
<p>▪ Sharing for affiliates’ everyday business purposes – information about your creditworthiness
▪ Affiliates from using your information to market to you
▪ Sharing for nonaffiliates to market to you</p>
<p>State laws and individual companies may give you additional rights to limit sharing.</p>
<p><strong>Definitions</strong></p>
<p><strong>Term</strong></p>
<p><strong>Meaning</strong></p>
<p><strong>Affiliates</strong></p>
<p>Companies related by common ownership or control. They can be financial and nonfinancial companies.</p>
<p>▪ Our affiliates include financial companies such as Legend Bank and Legend Bancorp, Inc.</p>
<p><strong>Nonaffiliates</strong></p>
<p>Companies not related by common ownership or control. They can be financial and nonfinancial companies.</p>
<p>▪ Legend Bank does not share with nonaffiliates so they can market to you.</p>
<p><strong>Joint marketing</strong></p>
<p>A formal agreement between nonaffiliated financial companies that together market financial products or services to you.</p>
<p>▪ Our joint marketing partners include debit card companies; insurance companies; and investment and advisory companies.</p>
</div></div>
`;

function PrivacyPolicy() {
  return <div dangerouslySetInnerHTML={{__html: htmlContent}} />;
}

export default PrivacyPolicy;
